export default __webpack_public_path__ + "static/media/FurnitureItem14.95c0cc11.png";